<template>
  <div class="active-filters" :key="update_key">
    <div class="active-filters__row">
      <div>
        <div
          v-for="(option, option_index) in filters.brand"
          :key="`brand_${option_index}`"
        >
          <div class="active-filters__brand">
            <vb-checkbox
              @change="(value) => $emit('filter', { key: 'brand', value })"
              v-model="option.selected"
              v-show="option.selected"
              :vb_options="{
                text: `${option.text} (${option.amount})`,
                value: option.selected,
              }"
            >
              <template #default>
                <div class="active-filters__brand-label">
                  <img :src="`assets/images/alpitour/liveat-brands/${option.logo}`" />&nbsp;&nbsp;({{ option.amount }})
                </div>
              </template>
            </vb-checkbox>
          </div>
        </div>

        <div
          v-for="(filter, filter_key) in non_brand_filters"
          :key="`btn_${filter_key}`"
        >
          <vb-checkbox
            class="active-filters__chip"
            v-for="(option, option_index) in filter"
            :key="`btn_${filter_key}_${option_index}`"
            v-show="option.selected"
            @change="(value) => $emit('filter', { key: filter_key, value })"
            v-model="option.selected"
            :vb_options="{
              text: `${option.text} (${option.amount})`.toLowerCase(),
              value: option.selected,
            }"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get_non_brand_filters } from '@alpitour/utilities/results-filters'

export default {
  name: "active-filters",
  props: {
    filters: {
      type: Object,
      default: () => ({}),
    },
    update_key: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    non_brand_filters() {
      return get_non_brand_filters(this.filters)
    },
  },
}
</script>

<style lang="scss" scoped>
.active-filters {
  &__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__chip {
    text-transform: capitalize;
  }

  &__brand {
    padding-left: 0;

    img {
      margin-left: 0.15rem;
      height: 16px;
      width: auto;
    }
  }

  &__brand-label {
    display: flex;
    align-items: center;
  }
}
</style>
